import * as React from 'react';
import * as styles from './segment-include-exclude-header.module.scss';

interface Props {
  isNew?: boolean;
  exclude?: boolean;
}

/**
 * Renders an Included or Excluded header
 */
const SegmentIncludeExcludeHeader = ({ isNew, exclude }: Props) => {
  return <h2 className={styles.includeExcludeHeader}>{`${exclude ? 'Exclude' : 'Include'}${isNew ? '' : 'd'}`}</h2>;
};

export default SegmentIncludeExcludeHeader;
